import { useMemo } from 'react';
import { useGetUserRolesQuery } from 'store/reducers/api/user';

const useUserTopRole = (id?: number | null) => {
  const { currentData: data } = useGetUserRolesQuery(id!, {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
    skip: !id
  });

  return useMemo(() => {
    const userTopRoleId = data ? Math.min(...data.map((item) => item.user_role_type_id)) : undefined;
    const userTopRole = data?.find((x) => x.user_role_type_id === userTopRoleId);
    return { userTopRoleId, userTopRole, userRoles: data };
  }, [data]);
};

export default useUserTopRole;
